import styled from 'styled-components'

export const MainContentStyles = styled.main`
  margin: 5rem 2.5rem;
`
